import { request, apiUrl, authHeaders } from '@/core/http';

// game categories
export function getGameCategories() {
    return request({
        url: apiUrl('game/getGameCategories'),
        method: 'get',
        headers: authHeaders()
    });
}

// get games by category (optionally filtered by vendorCode and member currency), paginated by page
export function getGame(category, vendorCode, currency, page) {
    let url = apiUrl(`game/getGame?category=${category}`);
    if (vendorCode) url += `&vendorCode=${vendorCode}`;
    if (currency) url += `&currency=${currency}`;
    if (page) url += `&page=${page}`;
    return request({
        url,
        method: 'get',
        headers: authHeaders()
    });
}

// launch game - returns gameUrl to open in new tab
export function launchGame(username, gameCode, wallet) {
    return request({
        url: apiUrl('seamless/launch'),
        method: 'post',
        data: { username, gameCode, wallet },
        headers: authHeaders()
    });
}

// transfer-wallet vendors (requires_transfer): create / get player account
export function getTransferPlayer(vendorCode) {
    return request({
        url: apiUrl(`game/${vendorCode.toLowerCase()}/player`),
        method: 'post',
        headers: authHeaders()
    });
}

// transfer-wallet vendors: move money in from wallet (point / point2 / point3)
export function transferIn(vendorCode, wallet, amount) {
    return request({
        url: apiUrl(`game/${vendorCode.toLowerCase()}/transfer-in`),
        method: 'post',
        data: { wallet, amount },
        headers: authHeaders()
    });
}

// transfer-wallet vendors: login - returns game url
export function transferLogin(vendorCode, gameCode) {
    return request({
        url: apiUrl(`game/${vendorCode.toLowerCase()}/login`),
        method: 'post',
        data: { gameCode },
        headers: authHeaders()
    });
}
